import { TranslateFn } from '~/shared/utils/translation/hooks/useTranslation';
import type { LoyaltyEndpoints } from './loyaltyEndpoints.js';

export const createLoyaltyQuery = (
    endpoint: LoyaltyEndpoints,
    translate: TranslateFn,
    trackError: (error: unknown) => void,
    params: Record<string, string | undefined>,
    options?: { suppressErrorToast?: boolean; trackOnlyError?: (error: unknown) => void },
) => {
    const cleanParams: Record<string, string> = {};

    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined) {
            cleanParams[key] = value;
        }
    }

    const query = new URLSearchParams(cleanParams).toString();

    if (!query) return;

    return async () => {
        const res = await fetch(`/api/loyalty/${endpoint}?${query}`);

        if (!res.ok) {
            const error = new Error(translate('basket.couldNotFetchLoyaltyData'));
            // Use trackOnlyError (silent tracking) if suppressErrorToast is true, otherwise use trackError (shows toast)
            if (options?.suppressErrorToast && options?.trackOnlyError) {
                options.trackOnlyError(error);
            } else {
                trackError(error);
            }
            throw error;
        }

        return res.json();
    };
};
